import React from 'react';
import { components } from 'react-select';
import SelectClearIcon from '@atlaskit/icon/glyph/select-clear';
export { ClearIndicator, DropdownIndicator, LoadingIndicator, } from './indicators';
export const MultiValueRemove = (props) => (React.createElement(components.MultiValueRemove, Object.assign({}, props),
    React.createElement(SelectClearIcon, { label: "Clear", size: "small", primaryColor: "transparent", secondaryColor: "inherit" })));
export const IndicatorSeparator = null;
//# sourceMappingURL=index.js.map